/**
 * Builds the URL for the Stripe customer portal (e.g. to add or manage payment methods).
 */
export function buildStripePortalUrl(locale?: string): string {
  const params = new URLSearchParams();
  if (locale != null && locale !== "") {
    params.set("locale", locale);
  }
  const qs = params.toString();
  const path = qs ? `/api/stripe-customer-portal?${qs}` : "/api/stripe-customer-portal";
  return path;
}
